import * as React from 'react';
import { SmartOptinsPostFormScreenConfiguration } from '@luckycart/xpn-types';

import { Background } from '../common-components/Background';
import { HtmlZone } from '../common-components/HtmlZone';
import { BlockInfoType } from '../../common-types/BlockInfo.type';

interface Props {
  config: SmartOptinsPostFormScreenConfiguration;
  addEditableBlock?: (block: BlockInfoType) => void;
  isEdition?: boolean;
  onBlockEdit?: React.MouseEventHandler<HTMLDivElement>;
}

export const SmartOptinsPostFormScreen: React.FunctionComponent<Props> = ({ config, addEditableBlock, isEdition, onBlockEdit } : Props) => {
  return (
    <Background
      displayName="Background"
      sizeInfo={{ height: 1200, width: 1200 }}
      addEditableBlock={addEditableBlock}
      dataTemplateConfig="screens.smartOptinsPostForm.background"
      backgroundImage={config.background.imageUrl}
      backgroundColor={config.background.color}
      isEdition={isEdition}
      onClick={onBlockEdit}
    >
      <HtmlZone
        displayName="HTML Zone"
        addEditableBlock={addEditableBlock}
        dataTemplateConfig="screens.smartOptinsPostForm.mainTextBox"
        html={config.mainTextBox.html}
        isEdition={isEdition}
        onClick={onBlockEdit}
      />
    </Background>
  );
};
